import {
  Block,
  Button,
  Discord,
  HeadingXSmall,
  ParagraphMedium,
  ParagraphSmall,
  useStyletron,
} from "@mezo-org/mezo-clay"

import SlideUpMenu, { SlideUpMenuProps } from "#/shared/components/SlideUpMenu"
import { useLinkDiscordToWalletAccount } from "#/shared/hooks"
import { WindowPopupStatus } from "#/shared/types"
import { FullContainerLoader } from "#/ui/Layout"

import OnboardingModalLink from "./OnboardingModalLink"

type OnboardingModalLinkDiscordProps = Pick<SlideUpMenuProps, "isOpen"> & {
  onClose: () => void
}

export default function OnboardingModalLinkDiscord({
  isOpen,
  onClose,
}: OnboardingModalLinkDiscordProps) {
  const { linkDiscord, linkingStatus, authorizationError } =
    useLinkDiscordToWalletAccount(onClose)

  const [css, theme] = useStyletron()

  return (
    <SlideUpMenu
      header="One more step..."
      isOpen={isOpen}
      onClose={onClose}
      closable={linkingStatus !== WindowPopupStatus.PENDING}
    >
      {linkingStatus === WindowPopupStatus.PENDING ? (
        <FullContainerLoader label="Authorizing..." padding="236px 0" />
      ) : (
        <Block
          className={css({
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "100%",
            height: "100%",
            gap: theme.sizing.scale500,
            padding: theme.sizing.scale800,
            textAlign: "center",
          })}
        >
          <Block
            className={css({
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              padding: "68px 0 90px",
            })}
          >
            <OnboardingModalLink color="#5865F2" Icon={Discord} />
            <HeadingXSmall
              marginTop={theme.sizing.scale1000}
              marginBottom={theme.sizing.scale500}
            >
              Connect your Discord to sign in fast <br />
              and safe with your social login.
            </HeadingXSmall>
            <ParagraphMedium>
              It&apos;s a simple way to get started without the hassle.
            </ParagraphMedium>
          </Block>
          <Block marginBottom={theme.sizing.scale200}>
            {authorizationError && (
              <ParagraphSmall color={theme.colors.contentNegative}>
                {authorizationError}
              </ParagraphSmall>
            )}
          </Block>
          <Button
            startEnhancer={<Discord color={theme.colors.white} />}
            onClick={linkDiscord}
            width="100%"
          >
            Connect Discord
          </Button>
          <Button kind="secondary" onClick={onClose} width="100%">
            Later
          </Button>
        </Block>
      )}
    </SlideUpMenu>
  )
}
